import { LayoutDashboard } from 'lucide-react';
import { stagger, useAnimate } from 'motion/react';
import { forwardRef, useImperativeHandle } from 'react';

interface AnimatedLayoutDashboardHandle {
  startAnimation: () => void;
  stopAnimation: () => void;
}

export const AnimatedLayoutDashboard = forwardRef<
  AnimatedLayoutDashboardHandle,
  { size?: number }
>(({ size = 20 }, ref) => {
  const [scope, animate] = useAnimate<SVGSVGElement>();

  useImperativeHandle(
    ref,
    () => ({
      startAnimation: () => {
        void animate(
          'rect',
          { opacity: [1, 0.5, 1], y: [0, -1, 0] },
          { duration: 0.4, delay: stagger(0.06), ease: 'easeInOut' }
        );
      },
      stopAnimation: () => {
        void animate('rect', { opacity: 1, y: 0 }, { duration: 0 });
      },
    }),
    [animate]
  );

  return <LayoutDashboard ref={scope} size={size} />;
});

AnimatedLayoutDashboard.displayName = 'AnimatedLayoutDashboard';
